<template>
<div class="grid mt-4">	


<template v-if="!is_connected">
<div class="col-12 ">
<h4 class="text-red-500">Bu modüle bağlı bir veri modülü bulunmuyor</h4>
</div>	
</template>


<template v-else>
	
<div class="col-12 ">
<h4 class="text-primary">Koşulllar</h4>
<hr>
</div>


<template v-if="$store.state.calculations.selectednode.data">

<div class="col-12" v-for="condition in $store.state.calculations.selectednode.data.conditions"> 
<Dropdown :filter="false"  v-model="condition.selected_input_id" :options="inputs" optionLabel="name"   class=" p-inputtext-sm mt-2 w-4" @change="inputSelected"/>

<InputText  type="number" v-model="condition.value" class="p-inputtext-sm ml-2 mt-2 w-2"    />

<Dropdown :filter="false"  v-model="condition.selected_operator" :options="operators" optionLabel="name"   class=" p-inputtext-sm ml-2 mt-2 w-4" @change="operatorSelected"/>

<Button icon="pi pi-trash"  class="p-button-outlined p-button-sm p-button-danger ml-2"   @click="removeCondition(condition.id)"></Button>


</div>



</template>





<div class="col-12">
<Button label="Yeni Ekle"  class="p-button-outlined p-button-sm p-button-primary"   @click="addCondition"></Button>
</div>







<template v-if="$store.state.calculations.selectednode.data && $store.state.calculations.selectednode.data.conditions.length">
<div class="col-12 ">
<h4 class="text-primary">Sonuç</h4>
<hr>
</div>

<div class="col-12 ">
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.customattribute.attribute" :options="custom_attributes" optionLabel="name"   class=" p-inputtext-sm mt-2 w-4 mr-1" @change="customAttributeSelected"/>
değerini 


<template v-if="$store.state.calculations.selectednode.data.customattribute.attribute">

<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.customattribute.morph_value_type" :options="comparison_types" optionLabel="name"  optionValue="code" class=" p-inputtext-sm mt-2 w-4 mr-1" />

<!-- morph_value_type selected-->
<template v-if="$store.state.calculations.selectednode.data.customattribute.morph_value_type">
 
<!-- data-->
<template v-if="$store.state.calculations.selectednode.data.customattribute.morph_value_type=='input'">
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.customattribute.morph_value" :options="inputs" optionLabel="name"  optionValue="stack_id" class=" p-inputtext-sm mt-2 w-4 mr-1 ml-1" /> 


</template>

<!-- data-->
<!-- value-->
<template v-if="$store.state.calculations.selectednode.data.customattribute.morph_value_type=='value'">

<template v-if="$store.state.calculations.selectednode.data.customattribute.attribute.type=='select'">
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.customattribute.numericalval" :options="$store.state.calculations.selectednode.data.customattribute.attribute.options" optionLabel="name"  optionValue="id" class=" p-inputtext-sm mt-2 w-4 mr-1 ml-1" /> 
</template>

<template v-if="$store.state.calculations.selectednode.data.customattribute.attribute.type=='boolean'">
<Dropdown :filter="false"  v-model="$store.state.calculations.selectednode.data.customattribute.numericalval" :options="boolean_options" optionLabel="name"  optionValue="id" class=" p-inputtext-sm mt-2 w-2 mr-1 ml-1" /> 
</template>

<template v-if="$store.state.calculations.selectednode.data.customattribute.attribute.type=='string'">
<InputText  type="text" v-model="$store.state.calculations.selectednode.data.customattribute.textval" class="p-inputtext-sm ml-2 mt-2 w-4"    />  
</template>

<template v-if="$store.state.calculations.selectednode.data.customattribute.attribute.type=='number'">
<InputText  type="number" v-model="$store.state.calculations.selectednode.data.customattribute.numericalval" class="p-inputtext-sm ml-2 mt-2 w-2"    /> 
</template> 
  
</template>
<!-- value-->




</template>
<!-- morph_value_type selected-->







	
</template>





olarak güncelle



</div>	

</template>




</template>


</div>
</template>

<script>
const conditionmodel = {
    		selected_input_id:null,
    		selected_operator:null,
    		value:0,
    	}
export default {

  name: 'CustomAttributeMorphDataNode',
  props:["custom_attributes"],
  data () {
    return {
    	
    	conditions:[],
    	selected_input:null,
    	selected_operator:null,
    	inputs:[
    	],
      comparison_types:[
      {name:"Veri",code:"input"},
      {name:"Tam Değer",code:"value"},
      ], 
    	boolean_options:[
    	{id:0,name:"Kapalı"},    	
    	{id:1,name:"Açık"}
    	],
    	operators:[
    	{id:"gt",name:"değerinden büyükse"},
    	{id:"st",name:"değerinden küçükse"},
      {id:"eq",name:"değerine eşitse"},
      {id:"ex",name:"değer girildiyse"}
    	],
    	name:null,
    	show_value_input:false,
    	thevalue:0,
    }
  },
  computed:{
  	is_connected()
  	{
  		if(this.$store.state.calculations.selectednode)
  		{
  			let selectednode = this.$store.state.calculations.selectednode
  			
  			
  			let connections = this.$store.state.calculations.connections
  			let the_connection = connections.findIndex((item)=>{return item.to == selectednode.id})
  			if(the_connection!==-1)
  			{
  				let root_node = this.findRootNode()
  				return true
  			}
  			return false
  		}
  		return false  		
  	},
  },
  methods:{
  	customAttributeSelected()
  	{
  		console.log(this.$store.state.calculations.selectednode)
  	},
  	removeCondition(id)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.conditions = selectednode.data.conditions.filter((item)=>{return item.id !== id})
  		this.updateNodeData(selectednode)
  	},
  	addCondition()
  	{
  		console.log(this.$store.state.calculations.selectednode)
  		let selectednode = this.$store.state.calculations.selectednode
      console.log("selectednode")
      console.log(selectednode)
  		if(!selectednode.data)
  		{
  			selectednode.data = {
  				conditions:[],
  				customattribute:{
  					attribute:null,
  					numericalval:null,
  					textval:null,
            morph_value_type:"value",
            morph_value:null,
  				},
  			}
  		}
  		
  		let condition = this.sanitizeArray(conditionmodel)
  		condition.id = this.generateId()
  		selectednode.data.conditions.push(condition)

  		this.updateNodeData(selectednode)



  	},
  	cancelValue()
  	{
  		this.show_value_input = false
  		this.thevalue = 0
  		this.selected_input = null
  	},
  	removeItem(id)
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let inputs = selectednode.data.output.inputs.filter((item)=>{return item.id !== id})
  		selectednode.data.output.inputs = inputs
  		this.updateNodeData(selectednode)
  	},
  	nameUpdated()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		selectednode.data.output.name = this.name
      	selectednode.title = this.name
  		this.updateNodeData(selectednode)
  	},
  	inputSelected()
  	{
  		
  	},
  	operatorSelected()
  	{


  	},
  	updateNodeData(selectednode)
  	{
  		let nodes = this.$store.state.calculations.nodes
  		let ind = nodes.findIndex((item)=>{return item.id == selectednode.id})
  		nodes[ind] = selectednode
  		this.$store.dispatch('calculations/setNodes',nodes)
      	this.$store.dispatch('calculations/setSelectedNode',selectednode)
  	},
  	findRootNode()
  	{
  		let selectednode = this.$store.state.calculations.selectednode
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let the_connection = connections.find((item)=>{return item.to == selectednode.id.toString()}) 
  		if(the_connection)
  		{  			
  			let from_node = this.findPrevNode(the_connection.from) 
        console.log(this.inputs) 			
  			return from_node
  		}
  		return "no_connection"
  	},
  	findPrevNode(nodeId)
  	{
  		let connections = this.$store.state.calculations.connections
  		let nodes = this.$store.state.calculations.nodes
  		let node = nodes.find((item)=>{return item.id == nodeId.toString()})
  		console.log("findPrevNode")
  		console.log(node)
  		if(node.key=="calculations")
  		{  				
  			let calculation_item = {
            stack_id:node.id,
            name:node.title,
            type:"calculation",
          }
          this.addToInputsStack(calculation_item)
  		}
  		//if prev node is not suppliers
  		if(node.type!=="suppliers")
  		{
  			let the_connection = connections.find((item)=>{return item.to == nodeId.toString()})
  			if(!the_connection)
  			{
  				return "no_connection"
  			}
  			let from_node = this.findPrevNode(the_connection.from) 
  			
  			
  			return from_node
  		}
  		//if prev node is not suppliers

  		//if prev node is suppliers
  		node = this.sanitizeArray(node)
  		let outputs = node.data.outputs
  		let filtered = outputs.filter((item)=>{
  				if(item.name.length>20)
  				{
  					item.name = item.name.substring(0, 120)+"..."
  				}
  				if(item.type=="section_points")
          {
            item.name = item.name+" - Aşama Bölüm Puanı"
            return item
          }
          if(item.type=="questionlist_points")
          {
            item.name = item.name+" - Aşama Puanı"
            return item
          }
          if(item.type=="inputfield_point")
          {
            item.name = item.name+" - Soru Puanı"
            return item
          }
          if(item.type=="questionlist_nonconformity_count")
          {
            item.name = item.name+" - Aşama Uygunsuzluk Sayısı"
            return item
          }
          if(item.type=="custom_attribute")
          {
            if(item.custom_attribute_type=="number")
            {
              item.name = item.name+" -  Özel Nitelik"
              return item
            }
          }

          if(item.type=="inputfield_submission")
          {
            if(item.column_id)
            {
              if(item.column_type=="number" || item.column_type=="custom")
              {
                item.name = item.name+" -  Aşama Soru Verisi"
                return item
              }
            }
            else
            {
              if(item.inputfield_type=="number")
              {
                item.name = item.name+" -  Aşama Soru Verisi"
                return item
              }
            }
          }

        })
  		for(let item of filtered)
  		{
  			this.addToInputsStack(item)
  		}
  		return node
  		//if prev node is suppliers

  	},
  	addToInputsStack(input)
  	{  		
  		this.inputs.push(input)
  	},

  },
}
</script>

<style lang="css" scoped>
</style>